/**
 * Unsaved changes (JF 2026-10-13): before something replaces the cost sheet being edited — opening another saved sheet
 * (also one's own), opening someone's sheet from the admin page, a new AI estimate, a blank sheet, replacing it with a
 * historical BOM, logging out — ask first when the current sheet has changes that are not saved.
 */
import { useStore } from "../store.ts";
import { tFor } from "./i18n.ts";

export function okToReplace(): boolean {
  const st = useStore.getState();
  if (!st.isDirty()) return true;
  const t = tFor(st.lang);
  return window.confirm(t(
    "The cost sheet you are editing has changes that are not saved. Continuing replaces it.\n\nOK = continue without saving · Cancel = stay and save first",
    "当前成本表有修改还没保存，继续会被替换掉。\n\n确定 = 不保存，继续 · 取消 = 留在当前表，先保存"));
}
